import { formatDate } from '../../../../../utils/dateFormat';
export { formatDate };

// Memoized visa provider renderer
export const renderVisaProvider = (item) => {
  return item.visa_provider || item.Overseas_visa_provider || "-";
};

// Memoized status renderer
export const renderTerminationStatus = (item) => {
  return item?.termination_status === null 
    ? "TERMINATION-FINAL EXIT" 
    : item?.termination_status;
};

// Memoized columns configuration
export const TERMINATION_FINAL_EXIT_COLUMNS = [
  { key: 'serial', title: 'S.NO.', searchable: false },
  { key: 'point_of_hire', title: 'POINT OF HIRE', searchable: true },
  { key: 'candidate_id', title: 'EMPLOYEE ID', searchable: true },
  { key: 'name', title: 'EMPLOYEE NAME', searchable: true },
  { key: 'nationality', title: 'NATIONALITY', searchable: true },
  { key: 'actual_profession', title: 'ACTUAL PROFESSION', searchable: true },
  { key: 'visa_profession', title: 'VISA PROFESSION', searchable: true },
  { key: 'total_salary', title: 'TOTAL SALARY', searchable: true },
  { key: 'client', title: 'CLIENT', searchable: true },
  { key: 'visa_provider', title: 'VISA PROVIDER', searchable: true },
  { key: 'iqama_number', title: 'IQAMA NUMBER', searchable: true },
  { key: 'iqama_expiry_date_g', title: 'IQAMA EXPIRY DATE', searchable: true },
  { 
    key: 'arrival_date', 
    title: 'ARRIVAL DATE', 
    searchable: true,
    render: formatDate
  },
  { 
    key: 'mobilization_date', 
    title: 'MOBILIZATION DATE', 
    searchable: true,
    render: formatDate
  },
  { 
    key: 'demobilization_date', 
    title: 'DEMOBILIZATION DATE', 
    searchable: true,
    render: formatDate
  },
  { key: 'demobilization_comments', title: 'DEMOBILIZATION COMMENTS', searchable: true },
  { key: 'idle_aging', title: 'TERMINATION AGING', searchable: true },
  { key: 'termination_status', title: 'STATUS', searchable: true },
  { key: 'action', title: 'ACTION', searchable: false }
];

// Constants for better maintainability
export const TERMINATION_FINAL_EXIT_CONFIG = {
  API_ENDPOINT: "/termination/getData/TERMINATION-FINAL EXIT",
  DOWNLOAD_ENDPOINT: "/termination/getData/download/TERMINATION-FINAL EXIT",
  DOWNLOAD_FILENAME: "Termination_summary",
  SEARCH_PLACEHOLDER: "Search by Employee ID, Name, Point of Hire, Nationality...",
  NO_DATA_MESSAGE: "No termination/final exit data available",
  DEBOUNCE_MS: 300,
  DEFAULT_PAGE_SIZE: 50,
  PAGE_SIZE_OPTIONS: [50, 100, 500, 1000]
};

// Memoized searchable fields derived from columns
export const TERMINATION_FINAL_EXIT_SEARCHABLE_FIELDS = TERMINATION_FINAL_EXIT_COLUMNS
  .filter(col => col.searchable)
  .map(col => col.key);

// Search key mapping for backward compatibility
export const SEARCH_KEY_MAPPING = [
  "employee_id",
  "visa_reference_number", 
  "border_number"
];